import React, { type JSX } from 'react';

function PlayIcon ({ playing }: { playing: boolean }): JSX.Element {
  return playing ? (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
      <path d="M6 5h4v14H6zm8 0h4v14h-4z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}

export default PlayIcon;
